module.exports = __webpack_public_path__ + "static/media/tmb_imgInfoM3.6104a634.png";